import BillingDashboard from "@/models/general/settings/BillingDashboard";
import current from "./current";
import paymentHistory from "./paymentHistory";
import paymentMethods from "./paymentMethods";
import emailNotifications from "./emailNotifications";

export default {
    namespaced: true,

    modules: {
        current,
        paymentMethods,
        paymentHistory,
        emailNotifications
    },

    actions: {

        async fetchBillingDashboardData({dispatch}) {
            dispatch('general/settings/billingDashboard/paymentMethods/getPaymentMethods', null, {root: true})
            dispatch('general/settings/billingDashboard/current/getCurrent', null, {root: true})
            dispatch('general/settings/billingDashboard/paymentHistory/getPaymentHistory', null, {root: true})
            dispatch('general/settings/billingDashboard/emailNotifications/getEmails', null, {root: true})
        },

        async calculateBilling({dispatch}, id) {
            const { data } = await BillingDashboard.calculateBilling(id);
            if (!data.error) {
                dispatch('fetchBillingDashboardData')  
            }
        
        }


    }
};
